import {
  EnhancedDataServicesApiKeyEntity,
  EnhancedDataServicesDocumentation,
  EnhancedDataServicesEntityData,
} from '../types';

const ENHANCED_DATA_SERVICES_TRADER_ENTITY_DOCUMENTATION_LIST: EnhancedDataServicesDocumentation[] =
  [
    {
      labelKey: 'enhancedDataServicesTraderDataDocumentation',
      link: '/assets/documentation/WSI Trader API Documentation.pdf',
    },
  ];

const ENHANCED_DATA_SERVICES_CLEANED_HISTORICAL_ENTITY_DOCUMENTATION_LIST: EnhancedDataServicesDocumentation[] =
  [
    {
      labelKey: 'enhancedDataServicesCleanedHistoricalDataDocumentation',
      link: 'https://www.atmosphericg2.com/ag2-cleaned-historical-observations-documentation',
    },
  ];

const ENHANCED_DATA_SERVICES_SUN_API_ENTITY_DOCUMENTATION_LIST: EnhancedDataServicesDocumentation[] =
  [
    {
      labelKey: 'enhancedDataServicesOtherDataServicesCoreDocumentation',
      link: 'https://twcapi.co/WCDC',
    },
    {
      labelKey: 'enhancedDataServicesOtherDataServicesSevereDocumentation',
      link: 'https://twcapi.co/WCDSEVW',
    },
    {
      labelKey: 'enhancedDataServicesOtherDataServicesLightningDocumentation',
      link: 'https://twcapi.co/WCDRLSUS',
    },
    {
      labelKey: 'enhancedDataServicesOtherDataServicesRenewablesDocumentation',
      link: 'https://twcapi.co/WCDRE',
    },
    {
      labelKey: 'enhancedDataServicesOtherDataServicesAgricultureDocumentation',
      link: 'https://twcapi.co/WCDA',
    },
    {
      labelKey:
        'enhancedDataServicesOtherDataServicesEnhancedForecastDocumentation',
      link: 'https://twcapi.co/WCDEF',
    },
    {
      labelKey:
        'enhancedDataServicesOtherDataServicesHistoryOnDemandDocumentation',
      link: 'https://twcapi.co/WCDHOD',
    },
    {
      labelKey:
        'enhancedDataServicesOtherDataServicesEnhancedConditionsDocumentation',
      link: 'https://twcapi.co/WCDECC',
    },
    {
      labelKey:
        'enhancedDataServicesOtherDataServicesProbabilisticForecastDocumentation',
      link: 'https://twcapi.co/WCDPF',
    },
  ];

export const ENHANCED_DATA_SERVICES_ENTITY_CONFIG_MAP: Record<
  EnhancedDataServicesApiKeyEntity,
  Pick<
    EnhancedDataServicesEntityData,
    'title' | 'description' | 'documentationList'
  >
> = {
  trader: {
    title: 'enhancedDataServicesTraderDataTitle',
    description: 'enhancedDataServicesTraderDataDescription',
    documentationList: ENHANCED_DATA_SERVICES_TRADER_ENTITY_DOCUMENTATION_LIST,
  },
  cleanedHistorical: {
    title: 'enhancedDataServicesCleanedHistoricalDataTitle',
    description: 'enhancedDataServicesCleanedHistoricalDataDescription',
    documentationList:
      ENHANCED_DATA_SERVICES_CLEANED_HISTORICAL_ENTITY_DOCUMENTATION_LIST,
  },
  sunApi: {
    title: 'enhancedDataServicesOtherDataServicesTitle',
    description: 'enhancedDataServicesOtherDataServicesDescription',
    documentationList: ENHANCED_DATA_SERVICES_SUN_API_ENTITY_DOCUMENTATION_LIST,
  },
};

export const ENHANCED_DATA_SERVICES_ENTITY_LIST_ORDER: EnhancedDataServicesApiKeyEntity[] =
  ['trader', 'cleanedHistorical', 'sunApi'];
